var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("AppNavigationSettings", { attrs: { open: true } }, [
    _c("div", { attrs: { id: "app-settings" } }, [
      _c("fieldset", [
        _c("ul", [
          _c(
            "li",
            [
              _c("ActionButton", {
                staticClass: "button",
                attrs: {
                  icon: _vm.scanningLibrary
                    ? "icon-loading-small"
                    : "icon-history",
                  title: _vm.t("cookbook", "Rescan library"),
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("reindex")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("li", [
            _c("label", { staticClass: "settings-input" }, [
              _vm._v(_vm._s(_vm.t("cookbook", "Recipe folder"))),
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: {
                type: "text",
                placeholder: _vm.t("cookbook", "Please pick a folder"),
              },
              domProps: { value: _vm.recipeFolder },
              on: { click: _vm.pickRecipeFolder },
            }),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("label", { staticClass: "settings-input" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(_vm.t("cookbook", "Update interval in minutes")) +
                  "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.updateInterval,
                  expression: "updateInterval",
                },
              ],
              staticClass: "input settings-input",
              attrs: { type: "number", placeholder: "0" },
              domProps: { value: _vm.updateInterval },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.updateInterval = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.printImage,
                  expression: "printImage",
                },
              ],
              staticClass: "checkbox",
              attrs: { id: "recipe-print-image", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.printImage)
                  ? _vm._i(_vm.printImage, null) > -1
                  : _vm.printImage,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.printImage,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.printImage = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.printImage = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.printImage = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "recipe-print-image" } }, [
              _vm._v(
                "\n                        " +
                  _vm._s(_vm.t("cookbook", "Print image with recipe")) +
                  "\n                    "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.showTagCloudInRecipeList,
                  expression: "showTagCloudInRecipeList",
                },
              ],
              staticClass: "checkbox",
              attrs: { id: "tag-cloud", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.showTagCloudInRecipeList)
                  ? _vm._i(_vm.showTagCloudInRecipeList, null) > -1
                  : _vm.showTagCloudInRecipeList,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.showTagCloudInRecipeList,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        (_vm.showTagCloudInRecipeList = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.showTagCloudInRecipeList = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.showTagCloudInRecipeList = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "tag-cloud" } }, [
              _vm._v(
                "\n                        " +
                  _vm._s(
                    // prettier-ignore
                    _vm.t("cookbook", "Show keyword cloud in recipe lists")
                  ) +
                  "\n                    "
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }